import { appApiSlice } from 'src/api/app-ApiSlice';
import { FeatureFlagResponse } from 'src/model/api/feature-flag.model';
import { GetPaidFeaturesResponse } from 'src/model/api/get-paid-features-response';

export const featureApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    isBelgianUser: builder.query<boolean, number>({
      query: (projectId: number) => `v1/feature/is-belgian-user?project_id=${projectId}`,
    }),
    featureFlag: builder.query<FeatureFlagResponse, void>({
      query: () => `v1/feature/feature-flag`,
    }),
    isTectlyAiEnabled: builder.query<boolean, void>({
      query: () => `v1/feature/is-tectly-ai-enabled`,
    }),
    getPaidFeatures: builder.query<GetPaidFeaturesResponse, number>({
      query: (projectId: number) => `v1/feature/get-paid-features?project_id=${projectId}`,
    }),
  }),
  overrideExisting: false,
});

export const {
  useIsBelgianUserQuery,
  useFeatureFlagQuery,
  useIsTectlyAiEnabledQuery,
  useGetPaidFeaturesQuery,
} = featureApiSlice;
